<script>
import AdminLayout from '@layouts/admin-main'
import BrokerageAdjustList from '@components/admin/brokerage-adjust-list'
import BrokerageNav from '@components/admin/brokerage-nav'

export default {
  page: {
    title: 'Admin::BrokerageCatalogAdjustList',
    meta: [
      { name: 'description', content: 'Admin::BrokerageCatalogAdjustList' },
    ],
  },
  components: { AdminLayout, BrokerageAdjustList, BrokerageNav },
}
</script>

<template>
  <AdminLayout>
    <BrokerageNav></BrokerageNav>
    <BrokerageAdjustList></BrokerageAdjustList>
  </AdminLayout>
</template>
